/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Transfer_Additive_NoteInputs */



/**
* | output |
* | --- |
* | "The chosen member becomes an administrator of those spaces and projects. Nobody loses access: personal spaces are not touched, and this member keeps their ow..." |
*
* @param {Member_Transfer_Additive_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_transfer_additive_note = /** @type {((inputs?: Member_Transfer_Additive_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Transfer_Additive_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das gewählte Mitglied wird Administrator dieser Spaces und Projekte. Niemand verliert Zugriff: persönliche Spaces bleiben unberührt, und dieses Mitglied behält seinen Zugriff, bis Sie es deaktivieren oder entfernen.")
	return /** @type {LocalizedString} */ ("The chosen member becomes an administrator of those spaces and projects. Nobody loses access: personal spaces are not touched, and this member keeps their own access until you deactivate or remove them.")
});